import { render, staticRenderFns } from "./MobileProjects.vue?vue&type=template&id=b601f05a&scoped=true"
import script from "./MobileProjects.vue?vue&type=script&lang=js"
export * from "./MobileProjects.vue?vue&type=script&lang=js"
import style0 from "./MobileProjects.vue?vue&type=style&index=0&id=b601f05a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b601f05a",
  null
  
)

export default component.exports